import gql from 'graphql-tag'

export default gql`
  query ($_id: MongoID) {
    content(filter: { _id: $_id }) {
      _id
      name
      public
      surveyconfig {
        surveyQuestions {
          questions
        }
        description {
          blocks
          entityMap
        }
      }
    }
  }
`
